import { BackButtonContainer, BackIcon, TextContainer } from '../styles';
import React, { FunctionComponent } from 'react';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  onPressBack?: VoidFunction;
}

export const BackButton: FunctionComponent<Props> = ({ onPressBack }: Props) => {
  return (
    <BackButtonContainer onClick={onPressBack}>
      <BackIcon icon={faArrowLeft} data-testid="modal-wrapper-back-button" />
      <TextContainer>Back</TextContainer>
    </BackButtonContainer>
  );
};
